export default {
    SET_UNITS(state, units) {
        state.units = units.map(function (unit) {
            if(!unit.label) {
                unit.label = unit.name;
            }
            return unit;

        });
    },

    SET_DEPARTMENTS(state, departments) {
        state.departments = departments.map(function (department) {
            if(!department.label) {
                department.label = department.name;
            }
            return department;
        });
    },

    SET_PRODUCTS(state, data) {
        state.products = _.get(data, 'products', []).map(function (product) {
            if(!product.label) {
                product.label = (data.hasSubdomain)
                  ? product.code
                  : `${product.code} - ${product.main_description}`;
            }
            return product;
        });
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/product/mutations.js